import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Checkbox from '@components/Form/Checkbox';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.base};
  color: #fff;
  text-transform: uppercase;
  display: flex;
  padding: 10px 56px 10px 70px;
  justify-content: space-between;
  position: relative;
`;

const Column = styled.div`
  font-weight: 300;
  flex: ${({ flex }) => flex};
  text-align: ${({ right }) => (right ? 'right' : 'left')};
`;

const SelectAllCheckbox = styled.div`
  position: absolute;
  left: 0;
  width: 54px;
  height: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.3);

  > div {
    height: 100%;
  }
`;

const ListHeader = ({ hideAlbumName, setFieldValue, tracks }) => {
  const selectAllHandler = select => {
    if (select) {
      const ids = tracks.map(track => track.id.toString());
      setFieldValue('ids', ids);
    } else {
      setFieldValue('ids', []);
    }
  };

  return (
    <Wrapper>
      <SelectAllCheckbox>
        <Checkbox
          name="selectAll"
          value="all"
          onChange={ev => {
            selectAllHandler(ev.currentTarget.checked);
          }}
        />
      </SelectAllCheckbox>
      <Column flex={0.3}>NO</Column>
      <Column flex={2}>Name</Column>
      <Column flex={1}>Version</Column>
      {!hideAlbumName ? <Column flex={1}>Album name</Column> : null}
      <Column flex={1} right>
        Actions
      </Column>
    </Wrapper>
  );
};

ListHeader.defaultProps = {
  hideAlbumName: false,
};

ListHeader.propTypes = {
  hideAlbumName: PropTypes.bool,
  tracks: PropTypes.arrayOf(PropTypes.object).isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default ListHeader;
